<template>
    <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-center">
        <small class="flex-grow-0 text-secondary">{{ filter.title }}</small>
        <div class="flex-grow-1 ml-lg-3">
            <b-form-datepicker
                v-model="date"
                :locale="'ru'"
                :label-no-date-selected="'Не выбрано'"
                :label-help="''"
                :reset-button="true"
                :label-reset-button="'Сбросить'"
                @input="onFilterChanged">
            </b-form-datepicker>
        </div>
    </div>
</template>

<script>
    import { DateSubmitProcessor } from "@/utils/dateFormat";

    export default {
        name: "DataTableDateFilter",
        props: {
            filter: { type: Object, default: () => { return {} } },
            initialValue: { type: String, default: null }
        },
        data() {
            return {
                date: null
            }
        },
        methods: {
            reset() {
                this.date = null;
            },
            resetValue(value) {
                this.date = null;
            },
            onFilterChanged() {
                if (this.date) {
                    let localDate = DateSubmitProcessor.convertDateToLocal(this.date);
                    const label = `${this.filter.title} ${localDate}`
                    this.$emit('filter-added', this.filter.name, localDate, label);
                } else {
                    this.$emit('filter-removed', this.filter.name);
                }

            },
        },
        mounted() {
            if (this.initialValue && this.initialValue['value']) {
                this.date = this.initialValue
            }
        }
    }
</script>

<style scoped>

</style>